import React, { FC, useContext, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { LeftPaneContext } from './LeftPaneContext';
import './AppCheckerConsole.css';

const NoErrorsMessage: FC = () => (
  <div id="no_errors_message" className="no-errors-message">
    <div className="fas fa-check"></div>
    <div className="message">There are no warnings in your application</div>
  </div>
);

export const AppCheckerConsole: FC = observer(() => {
  const {
    library,
    pendantNavigate,
    applicationErrorsWidget
  } = useContext(LeftPaneContext);
  const containerRef = useRef<HTMLDivElement>(null);
  const currentApplication = library.currentApplication;
  const errorCount = currentApplication.validationErrorCount;

  useEffect(() => {
    const currentApp = library.currentApplication;
    if (!currentApp || !containerRef?.current) return;

    const widget = applicationErrorsWidget(currentApp, pendantNavigate);
    containerRef.current.appendChild(widget.get(0));

    return () => {
      widget.remove();
    };
  }, [library.currentApplication]);

  return (
    <div
      ref={ containerRef }
      className={ cx('expand error-console', {
        hide_scroll: errorCount === 0
      }) }
    >
      { errorCount === 0 && <NoErrorsMessage/> }
    </div>
  );
});
